var exports = {
  "kL": "Source__HnrBmh",
  "jf": "SourceContent__hCWJJz",
  "UX": "PaintLayer__gTGcoc",
  "vk": "BackgroundOverlay__VC2CS-",
  "Sq": "TextareaLayer__ij3Gie",
  "TM": "Textarea__Wm0Vhs",
  "wh": "plainText__p1L5A3",
  "rL": "plainTextBelow__e-LKkm",
  "yE": "hiddenCaret__nvpr4o",
  "h8": "ControlledHighlight__25LOPs",
  "qV": "FocusedHighlight__o-8LXr",
  "_W": "AnchorHighlight__VMfRa9",
  "Bj": "AnchorHighlightContinued__ER-G5B",
};

module.exports = exports;
